<label for="{{optionId}}">
  <input id="{{optionId}}" (click)="toggleCheck()" type="checkbox" [checked]="isChecked" [value]="option.value" />
  @if (option.imgPath) {
    <span title="{{ option.label }}">
      <img src="{{option.imgPath}}" width="18px" height="18px" alt="{{ option.label }}" />
    </span>
  }
  @if (!option.imgPath) {
    @if (!toTranslate) {
      <span>{{ option.label }}</span>
    }
    @if (toTranslate) {
      <span>{{ option.label | uppercase | translate }}</span>
    }
  }
</label>
